import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { CellContentRoot } from "../../../../../LightTable";

const ModelCellContent: React.FC<ModelCellContent.Props> = ({ item }) => {
	const content = useMemo(() => item.model?.name ?? "", [item.model?.name]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ModelCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default ModelCellContent;
